import React from 'react'
import Topheader from '../../components/Topheader'
import style from './styles.module.css'
export default function Rewardpoints() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Puntos de Recompensa" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    P. ¿Qué son los Puntos de Recompensa?
                </div>
                <div className={style.sub_text3}>
                    Los Puntos de Recompensa son la moneda en el juego que ganas jugando, ganando torneos y alcanzando posiciones altas en las tablas de posiciones. Puedes canjearlos en la Baazi Store por ofertas exclusivas y tarjetas de regalo.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    P. ¿Qué puedo comprar con los Puntos de Recompensa?
                </div>
                <div className={style.sub_text3}>
                    Los Puntos de Recompensa se pueden canjear en la Baazi Store para obtener las increíbles recompensas disponibles actualmente. Se agregan nuevas recompensas regularmente, sigue revisando.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>P. ¿Necesito gastar dinero para obtener Puntos de Recompensa?</div>
                <div className={style.sub_text3}>No. Solo usa tus Fichas Gratuitas inteligentemente. Juega, compite y gana puntos. No se requiere ningún pago.</div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>P. ¿Los Puntos de Recompensa tienen fecha de vencimiento?</div>
                <div className={style.sub_text3}>No de inmediato, pero los puntos no utilizados pueden restablecerse durante los ciclos de actualización de temporada. Mantente activo para seguir subiendo y canjeando.</div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>P. ¿Hay un límite mensual de canjes?</div>
                <div className={style.sub_text3}>Sí, puedes realizar un máximo de 30 canjes por mes usando tus Puntos de Recompensa.</div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>P. ¿Se pueden convertir los Puntos de Recompensa en dinero?</div>
                <div className={style.sub_text3}>No. Los Puntos de Recompensa solo se pueden usar para canjear recompensas en la Baazi Store.</div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>P. Mis Puntos de Recompensa no se acreditaron. ¿Qué hago?</div>
                <div className={style.sub_text3}>
                    Actualiza la app o cierra sesión y vuelve a iniciar sesión. Si el problema persiste, comunícate con nosotros en <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> con tu nombre de usuario y los detalles del juego.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>P. Canjeé mis Puntos de Recompensa pero no recibí el artículo.</div>
                <div className={style.sub_text3}>
                    Por favor espera hasta 48 horas para el procesamiento. Si aún no lo recibes, comunícate con nosotros en <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> con el nombre de la recompensa elegida y la fecha de canje para obtener ayuda.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text3}>Para preguntas más detalladas, visita la sección de Puntos de Recompensa dentro de la app.</div>

            </div>
        </div>
    )
}
